export default Vue.reactive({
    formState: {},
    updateFormState(formState) {
        this.formState = formState;
    }
});